export const iconFontAwesomeChildhoodCookie = (
	<i className="fa-solid fa-cookie"></i>
);
